<!-- 组织架构 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_about.jpg"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="组织架构" en="ORGANIZATIONAL STRUCTURE"></sub-title>
        <img
          class="post"
          src="http://api.zyzxgc.cn/file/static/organization.png"
          alt=""
        />
        <img
          class="m"
          src="http://api.zyzxgc.cn/file/static/m_organization.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find((ele) => {
        const firstPath = this.$route.path.split("/")[1];
        return ele.path != "/" && "/" + firstPath == ele.path;
      });
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    background-image: url("http://api.zyzxgc.cn/file/static/organization_bg.png");
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 30px;

    .post {
      width: 100%;
      margin-bottom: 120px;
    }
    .m {
      display: none;
      width: 100%;
      margin-top: 40px;
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .post {
        display: none;
      }
      .m {
        display: block;
      }
    }
  }
}
</style>
